export default {
  name: 'lx-loader',
}
